import { useAppDispatch } from './useAppDispatcher.hook';
import { getRegionListThunk } from '../redux/Region/Region.thunk';
import { Region } from '../redux/Region/Region.type';
import { SelectOptionProps } from '../components/Input/Select.component';

const useRegionHook = () => {
  const dispatch = useAppDispatch();

  return {
    getSelectList: async (
      search: string,
      loadedOptions: string | SelectOptionProps[],
      { page, userRoleIds }: any,
    ) => {
      const {
        payload: { data, pagination },
      } = await dispatch(getRegionListThunk({ page, search }));
      return {
        options: data
          .filter(
            (item: Region) => !userRoleIds || userRoleIds.includes(item.id),
          )
          .map((item: Region) => ({
            value: item.id,
            label: item.name,
          })),
        hasMore: pagination.current_page < pagination.last_page,
        additional: {
          page: pagination.current_page + 1,
        },
      };
    },

    getSelectListOptionsByIds: async (ids: Array<number>) => {
      const {
        payload: { data },
      } = await dispatch(getRegionListThunk({ ids }));
      return {
        options: data
          ? data.map((item: Region) => ({
              value: item.id,
              label: item.name,
            }))
          : [],
      };
    },

    getSelectListByIds: async (ids: Array<number>) => {
      const {
        payload: { data },
      } = await dispatch(getRegionListThunk({ ids }));
      return data.map((item: Region) => ({
        value: item.id,
        label: item.name,
      }));
    },
  };
};

export default useRegionHook;
